<template>
  <v-card color="grey lighten-3" :dark="isDark" style="min-height: 64px">
    <v-layout row justify-end pa-2 wrap>
      <v-flex v-if="title || icon" justify-self-start>
        <v-layout row wrap>
          <v-flex shrink pt-1 pl-2 v-if="icon">
            <v-icon color="info" x-large>{{ icon }}</v-icon>
          </v-flex>
          <v-flex
            shrink
            headline
            pl-2
            pt-2
            info--text
            font-weight-medium
            v-if="title"
          >
            <template v-for="(crumb, index) in breadCrumbs">
              <span
                :key="index"
                @click="$emit('onClickBreadcrumb', crumb)"
                style="cursor: pointer"
              >
                <span style="cursor: pointer">
                  {{ crumb.text }}
                </span>
                <v-icon color="info">chevron_right</v-icon>
              </span>
            </template>
            {{ title }}
          </v-flex>
        </v-layout>
      </v-flex>
      <template v-for="(action, index) in actions">
        <v-flex
          shrink
          :key="index"
          v-if="
            !action.isVisibleFunc ||
            (action.isVisibleFunc && action.isVisibleFunc())
          "
        >
          <ControlButton
            :text="action.text"
            :icon="action.icon"
            :buttonColor="action.buttonColor"
            :iconColor="action.iconColor"
            :depressed="action.depressed"
            :disabled="
              (action.isDisabledFunc && action.isDisabledFunc()) || isLoading
            "
            :isLoading="isLoading && action.showIsLoading"
            @onClicked="$emit('onClicked', action.emitEvent)"
          />
        </v-flex>
      </template>
      <v-flex xs12 sm6 md5 lg4 v-if="shouldShowSearch">
        <v-text-field
          v-model="searchText"
          @input="onShouldSearch"
          v-on:keyup.enter="onShouldSearch"
          clearable
          solo
          label="Search"
          class="rounded"
          prepend-inner-icon="search"
          hide-details
        />
      </v-flex>
      <v-flex xs12 pr-2 pl-2 pt-1 v-if="$slots.toolbarExtension">
        <slot name="toolbarExtension" />
      </v-flex>
    </v-layout>
    <!-- <v-progress-linear
      v-if="isLoading"
      indeterminate
      color="info"
      style="margin: 0px"
    ></v-progress-linear> -->
  </v-card>
</template>

<script>
import ControlButton from '../controls/ControlButton'

export default {
  components: {
    ControlButton,
  },
  props: {
    search: String,
    shouldShowSearch: {
      type: Boolean,
      default: false,
    },
    breadCrumbs: {
      type: Array,
      default: () => [],
    },
    isDark: {
      type: Boolean,
      default: false,
    },
    isPrimary: {
      type: Boolean,
      default: true,
    },
    title: String,
    icon: String,
    isLoading: Boolean,
    actions: {
      type: Array,
      validator: (val) => {
        return val.every((action) => action.hasOwnProperty('emitEvent'))
      },
    },
  },
  data: () => ({
    searchText: null,
  }),
  computed: {
    color() {
      if (!this.isDark) {
        return
      }
      if (this.isPrimary) {
        return 'primary'
      }
      return 'secondary'
    },
  },
  methods: {
    onShouldSearch() {
      this.$emit('onShouldSearch', this.searchText)
    },
  },
}
</script>
